/**
 * Text constants for OTP verification drawer
 * Centralized location for all user-facing text to improve maintainability and localization
 */

export const OTP_TEXT = {
  EMAIL_NEW_CODE: 'Email me a new code',
  TEXT_NEW_CODE: 'Text me a new code',
  CALL_NEW_CODE: 'Call me with a new code'
} as const;

export const DRAWER_TEXT = {
  TITLE: 'Verify It\'s You',
  HEADER_PHONE_SMS: 'We sent a verification code to the following phone number:',
  HEADER_PHONE_CALL: 'We sent a verification code by calling the following phone number:',
  HEADER_EMAIL: 'We sent a verification code to the following email:',
  VERIFICATION_CODE: 'Verification Code',
  VERIFY_BUTTON: 'Verify Code',
  CANCEL_BUTTON: 'Cancel',
  REFRESH_CODE: 'Didn\'t get a code?',
  CODE_PLACEHOLDER: '6-digit code',
  CODE_INSTRUCTION: 'Enter your 6-digit verification code:'
} as const;

export const OTP_AUTH_ERROR = ['CUST_AUTH_ERR_118'];
